//
// Generated class AvailableRule
//

/// <reference path="AvailableRule_ManagedObject.ts" />

class AvailableRule extends AvailableRule_ManagedObject
{

}